// src/components/ScrollToTopButton.js
import React, { useState, useEffect } from 'react';
import { ChevronUpIcon } from '@heroicons/react/24/outline';

export default function ScrollToTopButton({ containerRef, threshold = 100 }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const onScroll = () => {
      setVisible(el.scrollTop > threshold);
    };

    // 1. 绑事件
    el.addEventListener('scroll', onScroll, { passive: true });
    // 2. 初始检查一次
    onScroll();

    return () => {
      el.removeEventListener('scroll', onScroll);
    };
  }, [containerRef, threshold]);

  const scrollToTop = () => {
    const el = containerRef.current;
    if (!el) return;
    el.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      aria-label="Back to top"
      className="fixed bottom-16 right-4 z-50 flex items-center justify-center p-3 rounded-full bg-blue-600 text-white shadow-lg hover:bg-blue-700 transition"
    >
      <ChevronUpIcon className="h-5 w-5" />
    </button>
  );
}
